/** @type {import('./commandQueue').CalendarCommandQueue | null} */
let activeCommandQueue = null;

export function registerCalendarCommandQueue(queue) {
   activeCommandQueue = queue || null;
}

export function getCalendarCommandQueue() {
   return activeCommandQueue;
}

/** @internal */
export function __resetCalendarCommandQueueRegistryForTests() {
   activeCommandQueue = null;
}
